import { Rss } from 'lucide-react'
import type { FeedEmbedCardProps } from './FeedEmbedCard.types'

export function FeedEmbedCard({ feed, onClick }: FeedEmbedCardProps) {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        onClick?.(feed.uri)
    }

    return (
        <button
            type="button"
            onClick={handleClick}
            className="w-full text-left border border-border-light dark:border-border-dark rounded-lg overflow-hidden hover:bg-surface-light/50 dark:hover:bg-surface-dark/50 transition-colors cursor-pointer"
        >
            <div className="flex items-start gap-3 p-3">
                {/* Feed avatar or fallback icon */}
                {feed.avatar ? (
                    <img
                        src={feed.avatar}
                        alt={feed.displayName}
                        className="w-10 h-10 rounded-lg flex-shrink-0 object-cover"
                        onError={e => {
                            e.currentTarget.style.display = 'none'
                        }}
                    />
                ) : (
                    <div className="w-10 h-10 rounded-lg flex-shrink-0 bg-primary/10 flex items-center justify-center">
                        <Rss className="w-5 h-5 text-primary" />
                    </div>
                )}

                <div className="flex-1 min-w-0">
                    {/* Feed name */}
                    <p className="text-sm font-semibold text-text-primary line-clamp-1">
                        {feed.displayName}
                    </p>

                    {/* Creator */}
                    <p className="text-xs text-text-secondary mt-0.5 truncate">
                        {/* eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- empty displayName should fall back to handle, not render blank */}
                        Feed by {feed.creator.displayName || `@${feed.creator.handle}`}
                    </p>
                </div>
            </div>
        </button>
    )
}
